import script from "./PasswordExpiredView.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordExpiredView.vue?vue&type=script&setup=true&lang=js"

import "./PasswordExpiredView.vue?vue&type=style&index=0&id=14909ca1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14909ca1"]])

export default __exports__